module.exports = __webpack_public_path__ + "media/images/Warm-Abstract-5-bb34348cdc60bf963072e1572c7ac1b0.png";